import script from "./FicheAffaireView.vue?vue&type=script&setup=true&lang=js"
export * from "./FicheAffaireView.vue?vue&type=script&setup=true&lang=js"

import "./FicheAffaireView.vue?vue&type=style&index=0&id=282244fc&lang=scss"

const __exports__ = script;

export default __exports__